const GET_TABLES_ERROR_TEXT = "Une erreur est survenue lors du chargement des tables.";
const ADD_TABLE_ERROR_TEXT = "Une erreur est survenue lors de l'ajout de la table.";
const DELETE_TABLE_ERROR_TEXT = "Une erreur est survenue lors de la suppression de la table.";
const UPDATE_TABLE_ERROR_TEXT = "Une erreur est survenue lors de la modification de la table.";

export const GET_TABLES_ERROR = GET_TABLES_ERROR_TEXT;
export const ADD_TABLE_ERROR = ADD_TABLE_ERROR_TEXT;
export const DELETE_TABLE_ERROR = DELETE_TABLE_ERROR_TEXT;
export const UPDATE_TABLE_ERROR = UPDATE_TABLE_ERROR_TEXT;


const GET_TABLELINKS_ERROR_TEXT = "Une erreur est survenue lors du chargement des liens de tables.";
const ADD_TABLELINK_ERROR_TEXT = "Une erreur est survenue lors de l'ajout du lien de tables.";
const DELETE_TABLELINK_ERROR_TEXT = "Une erreur est survenue lors de la suppression du lien de tables.";
const UPDATE_TABLELINK_ERROR_TEXT = "Une erreur est survenue lors de la modification du lien de tables.";

export const GET_TABLELINKS_ERROR = GET_TABLELINKS_ERROR_TEXT;
export const ADD_TABLELINK_ERROR = ADD_TABLELINK_ERROR_TEXT;
export const DELETE_TABLELINK_ERROR = DELETE_TABLELINK_ERROR_TEXT;
export const UPDATE_TABLELINK_ERROR = UPDATE_TABLELINK_ERROR_TEXT;

export const GET_TABLE_TYPES_ERROR = "Une erreur est survenue lors du chargement des types de tables.";


// WEBPACK FOOTER //
// ./src/errors/tables.js